import { UserDetails } from "./constant";

export const actionUserdetails = (data) => {

    return {
        type: UserDetails,
        data: data
    }
}